
import Bootstrap from "../../../assets/outline/Bootstrap.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BootstrapIcon({ className, dataTestid = "BootstrapIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Bootstrap data-testid={dataTestid} className={classes} {...rest} />
  );
}
